export const API_URL =
  process.env.REACT_APP_API_URL ||
  'https://games-store-backend.netlify.app/.netlify/functions/server';

export const PRODUCTS_ENDPOINT = `${API_URL}/products`;
export const ORDERS_ENDPOINT = `${API_URL}/orders`;
export const USERS_ENDPOINT = `${API_URL}/users`;

// export const postConfig = {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   }
// };
